export default "__VITE_PUBLIC_ASSET__855bd334__"